import React, { Fragment, useEffect, useState } from 'react'
import { StandardPage } from '../../components/_EOS/StandardPage'
import { GenericTableV2 } from '../../components/_EOS/GenericTable'
import { ApiResponse } from '../../typings/ApiResponse'
import { useApi } from '../../hooks/useApi'
import { usePagination } from '../../hooks/usePagination'
import { Status } from '../../hooks/useFetchState'
import Grid from '@mui/material/Grid2'
import { SnackBar } from '../../components/SnackBar/Snackbar'
import { StockReserveVsAvailableDto } from '../../components/StockReserve/types'
import { getReserveAvaiable } from '../../components/StockReserve/api'
import { MissingStockAlert } from '../../components/StockReserve/MissingStockAlert'
import { useProductOrigins } from '../../hooks'
import { Filter } from '../../components/_WMS/FilterComponent'
import { Search } from '../../components/StockReserve/StockReserveSearch'
import { defaultFilter, generateTableColumns } from './config'

interface PageProps {}

export const StockReservePage: React.FC<PageProps> = () => {
  const [snackbar, setSnackbarOptions] = useState({
    message: '',
    status: '',
    open: false
  })

  const pagination = usePagination(5)
  const { state, callApi, setIdle } = useApi<
    ApiResponse<StockReserveVsAvailableDto>
  >()
  const [orderBy, setOrderBy] = useState<{
    field: keyof StockReserveVsAvailableDto
    direction: 'asc' | 'desc'
  }>({
    field: 'SkuId',
    direction: 'desc'
  })

  const [selectedFilters, setSelectedFilters] = useState<Filter[]>(defaultFilter)

  const handleSorting = (
    field: keyof StockReserveVsAvailableDto,
    direction: 'asc' | 'desc'
  ) => {
    setOrderBy({ field, direction })
  }

  const handlePaginationChange = (page: number, pageSize: number) => {
    // If the pageSize is different, we should set page 0
    const auxPage = pagination.pageSize !== pageSize ? 0 : page

    NewRequest(selectedFilters, auxPage, pageSize)

    pagination.setPagination(auxPage, pageSize)
  }

  const handleSwapFilterAlertStock = () => {
    setSelectedFilters((prev) => {
      // Verificar si ya existe un filtro con key 'StockAlert'
      const stockAlertExists = prev.some(
        (filter) => filter.key === 'StockAlert'
      )

      if (stockAlertExists) {
        return prev // No volver a agregarlo si ya existe
      }

      const updatedFilters = [
        ...prev,
        {
          key: 'StockAlert',
          displayValue: 'Sin Stock',
          label: '',
          value: true
        }
      ]

      pagination.setPagination(0, pagination.pageSize)
      NewRequest(updatedFilters, 0, pagination.pageSize)

      return updatedFilters
    })
  }

  const {
    getProductOrigins,
    productOriginsState: { productOrigins }
  } = useProductOrigins()

  useEffect(() => {
    getProductOrigins()
  }, [])

  const columnsConfig = generateTableColumns(productOrigins)

  useEffect(() => {
    pagination.setPagination(0, pagination.pageSize)
    NewRequest(selectedFilters, 0, pagination.pageSize)
  }, [orderBy])

  const NewRequest = (filters?: Filter[], page?: number, pageSize?: number) => {
    callApi(getReserveAvaiable(filters, orderBy, page, pageSize)).catch(
      (error) => {
        console.log(error)
      }
    )
  }

  const handleSearchClick = (
    filters?: Filter[],
    page?: number,
    pageSize?: number
  ) => {
    // Al eliminar el último filtro no debe buscar automáticamente ni
    // mantener los resultados previos; debe esperar a que el usuario
    // agregue un filtro nuevamente
    if (!filters || filters.length === 0) {
      setIdle()
      return
    }

    NewRequest(filters, page, pageSize)
  }
  return (
    <Fragment>
      <StandardPage pageTitle=''>
        <Search
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          onSearchClick={handleSearchClick}
          includeAddButton={true}
          includeSearchOnClean={true}
        />
        <Fragment>
          <Grid container spacing={1} sx={{ mb: 1 }}>
            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 2, xl: 2 }}>
              <MissingStockAlert
                onClick={() => handleSwapFilterAlertStock()}
                title=''
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 5, md: 4, lg: 8, xl: 8 }}></Grid>
          </Grid>
          <GenericTableV2<StockReserveVsAvailableDto>
            data={state.data?.items || []}
            columns={columnsConfig}
            keyField='SkuId'
            loading={state.status === Status.Loading}
            pagination={{
              total: state.data?.totalItems || 0,
              page: pagination.page,
              pageSize: pagination.pageSize,
              onPageChange: handlePaginationChange
            }}
            sorting={{
              field: orderBy.field,
              direction: orderBy.direction,
              onSortChange: handleSorting
            }}
          />
        </Fragment>
      </StandardPage>
      <SnackBar
        message={snackbar.message}
        open={snackbar.open}
        status={snackbar.status}
        setOpen={() =>
          setSnackbarOptions({
            ...snackbar,
            open: false
          })
        }
      />
    </Fragment>
  )
}
